/* eslint-disable prefer-object-spread */
import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance';
import executor from '../../../data/axiosInstance/executor';

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;

const initialState = {
  mutliValutapolizza: [],
  actualValuta: "",
  selectedValutaDanneggiatoArray: [],
  selectedValutaIncaricoArray: []
};

/**
 * Dollaro(valuta scelta dall'utente) verso valuta di polizza
 */

/*
const valuteEUR = [
  {
    "nazione": "UNIONE MONETARIA EUROPEA",
    "descrizione": "Euro",
    "codice": "EUR",
    "tassoCambio": "1"
  },
  {
    "nazione": "Stati Uniti",
    "descrizione": "Dollaro USA",
    "codice": "USD",
    "tassoCambio": "0.93063"
  },
  {
    "nazione": "Regno Unito",
    "descrizione": "Sterlina Gran Bretagna",
    "codice": "GBP",
    "tassoCambio": "1.17423"
  },
  {
    "nazione": "Giappone",
    "descrizione": "Yen Giapponese",
    "codice": "JPY",
    "tassoCambio": "0.00620"
  },
  {
    "nazione": "ALBANIA",
    "descrizione": "Lek",
    "codice": "ALL",
    "tassoCambio": "0.00950"
  }
]

const valuteUSD = [
  {
    "nazione": "UNIONE MONETARIA EUROPEA",
    "descrizione": "Euro",
    "codice": "EUR",
    "tassoCambio": "1.0798"
  },
  {
    "nazione": "Stati Uniti",
    "descrizione": "Dollaro USA",
    "codice": "USD",
    "tassoCambio": "1"
  },
  {
    "nazione": "Regno Unito",
    "descrizione": "Sterlina Gran Bretagna",
    "codice": "GBP",
    "tassoCambio": "1.261"
  },
  {
    "nazione": "Giappone",
    "descrizione": "Yen Giapponese",
    "codice": "JPY",
    "tassoCambio": "0.0067"
  },
  {
    "nazione": "ALBANIA",
    "descrizione": "Lek",
    "codice": "ALL",
    "tassoCambio": "0.217"
  }
]

const valuteGBP = [
  {
    "nazione": "UNIONE MONETARIA EUROPEA",
    "descrizione": "Euro",
    "codice": "EUR",
    "tassoCambio": "0.9262"
  },
  {
    "nazione": "Stati Uniti",
    "descrizione": "Dollaro USA",
    "codice": "USD",
    "tassoCambio": "0.793"
  },
  {
    "nazione": "Regno Unito",
    "descrizione": "Sterlina Gran Bretagna",
    "codice": "GBP",
    "tassoCambio": "1"
  },
  {
    "nazione": "Giappone",
    "descrizione": "Yen Giapponese",
    "codice": "JPY",
    "tassoCambio": "0.00620"
  },
  {
    "nazione": "ALBANIA",
    "descrizione": "Lek",
    "codice": "ALL",
    "tassoCambio": "0.00950"
  }
]

*/

export const MultiValutaSlice = createSlice({
  name: 'multiValuta',
  initialState,
  reducers: {
    getMultiValutaPolizza: (state, action) => {
      state.mutliValutapolizza = action.payload;
    },
    setActualValuta: (state, action) => {
      state.actualValuta = action.payload;
    },
    setSelectedMultivaluta: (state, action) => {
      const { idDanneggiato, valuta } = action.payload;
      const ifDanneggiatoExist = state.selectedValutaDanneggiatoArray.findIndex(v => v.idDanneggiato === idDanneggiato);
      if (ifDanneggiatoExist !== -1) {
        state.selectedValutaDanneggiatoArray[ifDanneggiatoExist].valuta = valuta;
      } else {
        state.selectedValutaDanneggiatoArray.push({ idDanneggiato, valuta });
      }
    },
    setSelectedMultivalutaIncarico: (state, action) => {
      const { idIncarico, valuta, tassoCambioEur, disableButton } = action.payload;
      const ifIncaricoExist = state.selectedValutaIncaricoArray.findIndex(v => v.idIncarico === idIncarico);
      if (ifIncaricoExist !== -1) {
        state.selectedValutaIncaricoArray[ifIncaricoExist].valuta = valuta;
        state.selectedValutaIncaricoArray[ifIncaricoExist].tassoCambioEur = tassoCambioEur;
        state.selectedValutaIncaricoArray[ifIncaricoExist].disableButton = disableButton;
      } else {
        state.selectedValutaIncaricoArray.push({ idIncarico, valuta, tassoCambioEur, disableButton });
      }
    }
  }
});

export const { getMultiValutaPolizza, setActualValuta, setSelectedMultivaluta, setSelectedMultivalutaIncarico } = MultiValutaSlice.actions;

export const fetchMultiValutaPolizza = (valutaPolizza, actualValutaPolizza) => async (dispatch) => {
  if (actualValutaPolizza !== valutaPolizza) {
    dispatch(getMultiValutaPolizza([]));
    const uuID = crypto.randomUUID();
    const accessToken = localStorage.getItem('access_token');
    const idFlussoLocal = localStorage.getItem('idFlusso');
    const currentLanguage = localStorage.getItem('lang');

    const API_URI_CALL = `${API_URL}/api/v1/bff/tassoCambio/multivaluta/EUR`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {
      headers: { Authorization: `Bearer ${accessToken}`, requestId: uuID, idFlusso: idFlussoLocal, Language: currentLanguage }
    });
    const [res, err] = await executor.executeAsync(fetchData);
    console.log('res', res);
    console.log('err', err);
    if (res) {
      dispatch(setActualValuta(valutaPolizza));
      return dispatch(getMultiValutaPolizza(res.data));
    }
    return err

    /*
    switch (valutaPolizza) {
      case "EUR":
        return dispatch(getMultiValutaPolizza(valuteEUR));   
        
      case "GBP":
        return dispatch(getMultiValutaPolizza(valuteGBP));   
    
      case "USD":
        return dispatch(getMultiValutaPolizza(valuteUSD));   
    
      default:
        return dispatch(getMultiValutaPolizza(valuteEUR));   
      }
    */
  }
  return null;
};

export const handleChangeValutaIncarico = (valuta, incaricoId, requestId) => async () => {
  const uuID = requestId || crypto.randomUUID();
  const API_URI_CALL = `${API_URL}/api/v1/bff/incarichi/updateValuta/${incaricoId}`;
  const fetchData = async () => axiosInstance.put(
    API_URI_CALL,
    { valuta },
  );
  const [res, err] = await executor.executeAsync(fetchData);
  if (err) throw err;
  return {res, uuID};
}



export default MultiValutaSlice.reducer;
